<template>
  <v-app>
    <v-app-bar
      app
      dark
      :src="require('@/assets/pergaminho9.png')"
      class="pa-0 ma-0"
    >
      <div class="d-flex align-center" style="margin-left:12%">
          <router-link to="/" >
              <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :src="require('@/assets/logo.png')"
          transition="scale-transition"
          width="40"
        />
    </router-link>

        <h2>{{$route.name}}</h2>
      </div>
      

      <v-spacer></v-spacer>
      <div style="margin-right:10%">
                                   <v-btn
        :href="dataAPI + '/api-docs/'"
        target="_blank"
        text
      >
        <span class="mr-2">API</span>
      </v-btn>
             <v-btn
        @click="$router.push('openNLP')"
        target="_blank"
        text
      >
        <span class="mr-2">OpenNLP</span>
      </v-btn>

       <v-btn
        @click="$router.push('spaCy')"
        target="_blank"
        text
      >
        <span class="mr-2">spaCy</span>
      </v-btn>
      <v-btn
        @click="$router.push('tensorFlow')"
        target="_blank"
        text
      >
        <span class="mr-2">TensorFlow</span>
      </v-btn>
     <v-btn
        @click="$router.push('bert')"
        target="_blank"
        text
      >
        <span class="mr-2">BERT</span>
      </v-btn> 
      <v-btn
        @click="$router.push('DataSets')"
        target="_blank"
        text
      >
        <span class="mr-2">Corpora</span>
      </v-btn>
            <v-btn
        @click="$router.push('Parsers')"
        target="_blank"
        text
      >
        <span class="mr-2">Parsers</span>
      </v-btn>
            <v-btn
        @click="$router.push('Annotator')"
        target="_blank"
        text
      >
        <span class="mr-2">Annotator</span>
      </v-btn>


      </div>
    </v-app-bar>

<v-main  class="pa-0 ma-0 grey lighten-3" >
        <div :style="{'background-image': 'url('+ require('@/assets/wall9.jpg')+')','background-repeat': 'repeat-y','height':'100%'}">
          <transition name="fade"  mode="out-in">
      <router-view class="view"/>
  </transition>
  </div>
         </v-main>
    <v-footer
 
      color="#292929"
      
      height="100"
      :style="{'background-image': 'url('+ require('@/assets/pergaminho9.png')+')','background-position': 'center','background-size': '100%'}"
    >
            <v-row  style="margin-left:12%;margin-right:10%">
      <v-col cols=12 md="6">
      <div class="title font-weight-light white--text text--lighten-1 text-left" style="width:100%">
        <b>Master Thesis:</b> NER in Archival Descriptions<br>
        Nov 2021 — University of Minho 
        
       
      </div>
       </v-col>
       
       <v-col>
             <div class="title font-weight-light white--text text--lighten-1 text-right" style="width:100%">
                <b>Author:</b> <a style="color:white" href="mailto:a83099@alunos.uminho.pt">Luís Filipe Costa Cunha</a> <br>
                <b>Supervisor:</b> <a style="color:white" href="mailto:jcr@di.uminho.pt"> José Carlos Ramalho</a> 
       
      </div>
        </v-col>
      </v-row>
      
    </v-footer>
  </v-app>
</template>

<script>
const dataAPI = require("@/config/hosts").dataAPI;
export default {
  name: 'App',
  
  data: () => ({
    dataAPI: dataAPI,
  }),
};
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
a {
    color: #fff;
}



.loading {
    position: fixed;
    top: 0; right: 0;
    bottom: 0; left: 0;

    filter: alpha(opacity=40);
    z-index:1000000;

     background-color:rgb(236, 234, 234,0.4);
    z-index:100;

}
.loader {
    left: 50%;
    margin-left: -4em;
    font-size: 10px;
    border: .8em solid rgba(218, 219, 223, 1);
    border-left: .8em solid #AD8744;
    animation: spin 1.1s infinite linear;
    z-index:10000;
    opacity: 1;
}
.loader, .loader:after {
    border-radius: 50%;
    width: 8em;
    height: 8em;
    display: block;
    position: absolute;
    top: 50%;
    margin-top: -4.05em;
    z-index:10000;
    opacity: 1;
}

@keyframes spin {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
